import request from '../../helper/request';

export function getCompanies(params) {
  return request('/companies', { method: 'GET', params });
}

export function getCompany(id) {
  return request(`/companies/${id}`, { method: 'GET' });
}

export function createCompany(params) {
  return request('/companies', { method: 'POST', data: params });
}

export function updateCompany(params, id) {
  return request(`/companies/${id}`, { method: 'PATCH', data: params });
}

export function removeCompany(id) {
  return request(`/companies/${id}`, { method: 'DELETE' });
}

export function createSetupIntent(companyId) {
  return request(`/companies/${companyId}/setup-intent`, { method: 'POST' });
}

export function listPaymentMethods(companyId) {
  return request(`/companies/${companyId}/payment-methods`, { method: 'GET' });
}

export function addCompanyClients(companyId, clientIds) {
  return request(`/companies/${companyId}/clients`, { method: 'POST', data: { clientIds } });
}

export function removeCompanyClient(companyId, clientId) {
  return request(`/companies/${companyId}/clients/${clientId}`, { method: 'DELETE' });
}
